module.exports = __webpack_public_path__ + "static/media/tomorrow-edition-2025-social-image.1db1c669.jpg";